// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2ypId","container":"styles_container__22YN_","title":"styles_title__1KOcg","wrapper":"styles_wrapper__11fUc","answer":"styles_answer__22fSC"};